module.exports = __webpack_public_path__ + "6a4de14c1cdd267c5c9812068905b1b7.png";